module.exports = __webpack_public_path__ + "img/18.a1c8779b.png";